import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'

/**
 * Explains where team members manage their own profile / password vs admin-only user list.
 */
const UsersSelfServiceHint: React.FC = () => {
  const intl = useIntl()

  const accountLabel = intl.formatMessage({id: 'MENU.MY_ACCOUNT'})

  return (
    <div
      role='note'
      className='rounded border border-dashed border-gray-400 bg-light d-flex gap-5 p-6 mb-6 align-items-start'
    >
      <i className='bi bi-info-circle-fill text-primary fs-2 flex-shrink-0' aria-hidden />
      <div className='fs-6 text-gray-800'>
        <div className='fw-semibold mb-3'>
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.TITLE'})}
        </div>
        <p className='mb-3'>
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.INTRO_LINE_BEFORE'})}{' '}
          <Link to='/crafted/account/overview' className='fw-semibold'>
            {accountLabel}
          </Link>
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.INTRO_LINE_AFTER'})}{' '}
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.TABS_HINT'})}
        </p>
        <p className='mb-2 fw-semibold text-gray-700'>
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.LIST_THIS_PAGE'})}
        </p>
        <p className='mb-0 text-gray-700'>
          {intl.formatMessage({id: 'USERS.SELF_SERVICE.FORGOT_LINE'})}
        </p>
      </div>
    </div>
  )
}

export default UsersSelfServiceHint
